module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAbCAMAAACkwzTUAAAAclBMVEUAAAD/AADMADPVFSvVDivMFCnLDybNEyXQECTOECXPESbNESXOESXPESXPEibNESXNEibOESbOESbPEiXOESXNESXOECXPESXOESXNESXOESXOEiXOESbOESXOESXOESXOESXOESXOESXOESXOESX///+dtYjUAAAAJHRSTlMAAgUMEhkiKTE+SkxZWmV2gIiirri5u8jX2OLp7u/x9fb6/P4yzzNHAAAAAWJLR0QlwwHJDwAAAHJJREFUKM+N0ksSgkAMRVEEQRQRQUXwAyh3/2tk3twBGZ5KdaXzEhX99DhEYX2B8RIqANz2pryOpvzrWBSemSlDaQpNYkqfm/K77kShTU15n0yZK1M+m3v1XZtB59W/2R6G88b9ahaaW5ix30PRTffV7Swmzi8IcTdElgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/next.png
// module id = 3aVt
// module chunks = 2